/**
 * A campaign page view shows campaign data fetched for that view (#6826).
 *
 * Opening the overview or an ad page refetches the campaign once, unless the cached copy is only moments old: the
 * route loader fetches it for a cold load, and a view opened straight after another needs no second copy. The
 * window is short so a view never shows work that finished a while ago.
 */
export const CAMPAIGN_VIEW_FRESH_MS = 10_000;

export function isCampaignViewStale(dataUpdatedAt: number, now: number): boolean {
  return now - dataUpdatedAt > CAMPAIGN_VIEW_FRESH_MS;
}
